// Dialog utilities
import styled from "styled-components";

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 2vh;
  margin-right: 2vh;
`;

export const ButtonRow = styled(FormRow)`
  flex-flow: row-reverse;
`;
